import React from "react";
import { RouteProps, Route, Redirect, useLocation } from "react-router-dom";
import { useStore } from "../../store/useStore";
import { CognitoGroups } from "../../models/CognitoUser";
import UnauthorizedPage from "../../pages/UnauthorizedPage/UnauthorizedPage";
import useRoleAccess from "../../hooks/useRoleAccess";
import { DeferredLoadingFlags } from "../../util";
import { LoadingPage } from "../../pages/LoadingPage";

export type ProtectedRedirectHistoryState = {
  redirectUrl?: string;
};

export type ProtectedRouteProps = RouteProps & {
  requiredRoles?: CognitoGroups[];
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRoles,
  ...props
}) => {
  const { state } = useStore();
  const { user } = state;
  const { hasRoles } = useRoleAccess();
  const location = useLocation();

  if (state.loading.has(DeferredLoadingFlags.SILENT_AUTH))
    return <LoadingPage tip="Authenticating" />;
  if (!user) {
    return (
      <Redirect
        to={{ pathname: "/login", state: { redirectUrl: location.pathname } }}
      />
    );
  }

  /**
   * Routes are role protected as well as auth protected
   * Check roles here
   */
  if (!hasRoles(requiredRoles).oneOf())
    return (
      <Route {...props} render={undefined}>
        <UnauthorizedPage />
      </Route>
    );

  return <Route {...props} />;
};

export default ProtectedRoute;
